module.exports = __webpack_public_path__ + "static/media/mptc-logo.15947542.svg";